/* eslint-disable no-case-declarations */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@material-ui/core";
import { Autocomplete, Box, createFilterOptions } from "@mui/material";

import { Button } from "../../../../shared/widgets";
import { PageWrapper, TableWrapper } from "../../../../shared/layout";
import { templateStrings } from "../../../../Constant";
import OperatorConfigModal from "./OperatorConfigModal";
import { fetchCityOperatorsAction } from "../../../../redux/action-creators/operatorSettlementConfig";
import { setSettlementCycle } from "../../../../redux/actions/operatorSettlementConfigAction";

const filterOptions = createFilterOptions({
  matchFrom: "any",
  stringify: (option) => option.cityName,
  limit: 500,
});

const renderOption = (params, option) => (
  <li {...params} key={option.cityId}>
    {option.cityName}
  </li>
);

function OperatorConfig() {
  const dispatch = useDispatch();

  const content = useSelector(
    (state) => state.OperatorSettlementConfig.cityOperatorsList.data || [],
  );

  const availableConfigs = useSelector(
    (state) => state.OperatorSettlementConfig.cityOperatorsList.availableConfigs || [],
  );

  const totalItems = useSelector(
    (state) => state.OperatorSettlementConfig.cityOperatorsList.totalItems ?? 0,
  );

  const refresh = useSelector(
    (state) => state.OperatorSettlementConfig.isSettlementCycleSaved.success,
  );

  const headerLoader = useSelector((state) => state?.loadingBar?.header);

  const [selectedCity, setSelectedCity] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageNo, setPageNo] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [sortBy, setSortBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState({});

  const templateString = templateStrings.operatorConfig;
  const getList = useCallback(() => {
    dispatch(fetchCityOperatorsAction({
      cityId: selectedCity.cityId,
      pageNo,
      pageSize: rowsPerPage,
    }));
  }, [dispatch, selectedCity.cityId, pageNo, rowsPerPage, open]);

  const cities = useSelector((state) => state.Cities.cities);

  const handleAction = useCallback(
    (actionProps) => {
      setRowData(actionProps);
      setOpen(!open);
    },
    [open],
  );

  const toggleModal = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const isSettlementButtonDisabled = useCallback(() => {
    const settlementType = content.find((item) => item.operatorId === selected[0])?.cycleType;
    return selected.some((eachId) => {
      const operatorCycle = content.find((item) => item.operatorId === eachId)?.cycleType;
      return operatorCycle !== settlementType;
    }) || selected.length === 0;
  }, [content, selected]);

  const handleChange = useCallback(
    (input, value) => {
      switch (input) {
        case "pageNo":
          setPageNo(value);
          break;
        case "rowsPerPage":
          setRowsPerPage(value);
          break;
        case "selected":
          const selectedOperatorId = !value.length ? [] : value;
          setSelected(selectedOperatorId);
          break;
        default:
          break;
      }
    },
    [selected],
  );

  useEffect(() => {
    if (selectedCity?.cityId) {
      getList();
    }
  }, [selectedCity, pageNo, rowsPerPage]);

  useEffect(() => {
    if (refresh) {
      getList();
      dispatch(setSettlementCycle({ success: false }));
    }
  }, [refresh]);

  useEffect(() => {
    if (!open) {
      setRowData({});
    }
  }, [open]);

  return (
    <div className="pageContainer">
      <PageWrapper>
        <PageWrapper.Header
          heading="Operator Settlement Configuration"
          hideS
          removeFilterOnly
        >
          <div className="flex pull-right">
            {selectedCity?.cityName && (
              <Box marginRight={1}>
                <Button
                  classname="button-container operator-config"
                  onClick={toggleModal}
                  buttonText="Select Settlement Cycle"
                  disable={isSettlementButtonDisabled()}
                />
              </Box>
            )}
            <Autocomplete
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: 43,
                  width: 250,
                  padding: "0 0 0 9px",
                },
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  borderColor: "black", // Set the border color to black
                  backgroundColor: "white",
                  zIndex: -1,
                  height: 45,
                  padding: 0,
                },
                "& .MuiInputLabel-outlined": {
                  transform: "translate(10px, 12px) scale(1)",
                },
                "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                  transform: "translate(7px, -6px) scale(0.75)",
                },
                "& .MuiIconButton-root": {
                  padding: 0,
                  margin: 0,
                },
                "& .MuiInputBase-root": {
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                },
                "& .Mui-focused": {
                  borderColor: "black",
                },

              }}
              data-testid="operator-config"
              value={selectedCity}
              getOptionLabel={(option) => option.cityName || ""}
              options={cities}
              filterOptions={filterOptions}
              onChange={(event, newValue) => setSelectedCity(newValue || {})}
              renderInput={(params) => (
                <TextField {...params} label="Select City" variant="outlined" />
              )}
              renderOption={renderOption}
            />
          </div>
        </PageWrapper.Header>
        {!selectedCity?.cityName ? (
          <Box className="operator-config-body">
            Select city to view operators!
          </Box>
        ) : (
          <PageWrapper.Body>
            <TableWrapper
              content={!headerLoader && content}
              selected={selected}
              pageNo={pageNo}
              uniqueKey="operatorId"
              rowsPerPage={rowsPerPage}
              count={totalItems}
              handleChange={handleChange}
              templateString={templateString}
              selectionAllowed
              actionName="Edit"
              handleAction={handleAction}
              // onSortToggle={onSortToggle}
              sortBy={sortBy}
            />
            {open && (
              <OperatorConfigModal
                open={open}
                setOpen={setOpen}
                rowData={rowData}
                getList={getList}
                selected={selected}
                selectedCity={selectedCity}
                availableConfigs={availableConfigs}
                setSelected={setSelected}
              />
            )}
          </PageWrapper.Body>
        )}
      </PageWrapper>
    </div>
  );
}

export default OperatorConfig;
